<template>
    <div class="fxjcView" v-loading="riskLoading">
        <!--列表-->
        <div class="riskBox" v-show="isShowType == 'list'" v-loading="orderLoading">
            <div class="riskList" v-for="(item,index) in riskList" :key="index">
                <div class="riskListLeft">
                    <div class="riskListName">
                        <span>{{ item.companyName }}</span>
                        <span class="riskListKT">已开通</span>
                    </div>
                    <div class="riskListNumber">
                        <span>统一社会信用代码: </span>
                        <span>{{ item.taxpayerId }}</span>
                    </div>
                    <div class="riskListhandle">
                        <div class="riskListhandleY" @click="goLook(item)" >阅读报告</div>
                        <div class="riskListhandleS" @click="goJSP(item)" v-loading="authLoading">数据采集</div>
                    </div>
                </div>
                <div class="riskListRight">
                    <div class="riskListMoney">
                        <span @click="goMallOrder">服务订单</span>
                        <img :src="imgObj.icon_r" alt="">
                    </div>
                    <div class="riskListEndTime">
                        <span>到期日: </span>
                        <span>{{ item.endTime }}</span>
                    </div>
                    <div class="riskListRightBuy">
                        <div class="riskListEWM">
                            <img :src="imgObj.icon_ewm" alt="">
                        </div>
                        <div class="riskListAdd" @click="openAddBtn">开通服务</div>
                        <div class="riskListGoBuy" @click="goMall">续费服务</div>
                    </div>
                </div>
            </div>
        </div>
        <!--添加服务-->
        <div class="addView" v-if="isShowType == 'add'">
            <div class="addViewTop">
                <img :src="imgObj.icon_tz" alt="">
                <span>输入待检查企业名称及社会统一信用代码</span>
                <div class="returnListBtn" @click="returnList">返回</div>
            </div>
            <div class="addInputBox">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="企业名称" prop="companyName">
                        <el-input placeholder="请输入企业名称" maxlength="50" v-model="ruleForm.companyName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="税号" prop="taxpayerId">
                        <el-input placeholder="请输入15 18 20 位数税号" v-model="ruleForm.taxpayerId" clearable></el-input>
                    </el-form-item>
                </el-form>
                <div class="addRiskBtn" @click="addSubmitClick('ruleForm')" v-loading="addRiskLoading">提交</div>
            </div>
        </div>
        <!--展示阅读报告-->
        <div class="lookView" v-if="isShowType == 'look'" v-loading="fileLoading">
            <div class="lookViewTop">
                <img :src="imgObj.icon_tz" alt="">
                <span>可以下载查看已授权的风险报告</span>
                <div class="returnListBtn" @click="returnList('look')">返回</div>
            </div>
            <div class="orderListBox">
                <div class="orderList" v-for="(item,index) in orderList" :key="index">
                    <div class="orderListTop">
                        <span>授权风险报告</span>
                        <span class="orderListTopStatus">{{ stateFN(item.status) }}</span>
                        <div class="listDelete" @click="listDelete(item)">
                            <img :src="imgObj.icon_delete" alt="">
                        </div>
                    </div>
                    <div class="orderListBottom">
                        <div class="orderListBottomTime">
                            <img :src="imgObj.icon_date" alt="">
                            <span>{{ item.createTime }}</span>
                        </div>
                        <div class="orderListBottomDown" @click="uploadFile(item)">
                            <img :src="imgObj.icon_w" alt="">
                            <span>阅读全文</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--无数据-->
        <div class="notData" v-if="isShowType == 'not'">
            <div class="imgBox">
                <img :src="imgObj.icon_wu" alt=""> 
            </div>
            <p class="notDataText1">您还没有开通服务</p>
            <p class="notDataText2">输入企业信息,获取企业税务风险分析报告帮助企业实现财税合规</p>

            <div class="openAddBtn" @click="openAddBtn">立即开通服务</div>
        </div>
    </div>
</template>
<script>

//图片
import icon_wu from '@/assets/icon/wu.png'
import icon_tz from '@/assets/icon/tz.png'
import icon_r from '@/assets/icon/r.png'
import icon_ewm from '@/assets/icon/ewm.png'
import icon_delete from '@/assets/icon/delete.png'
import icon_w from '@/assets/icon/w.png'
import icon_date from '@/assets/icon/date.png'



//接口
import { getRiskList,getAddRisk,getAuth,getAuthOrder,getAuthOrderDetail,getAuthOrderDelete } from '@/api/api.js'


export default{
    name:'',
    data(){
        return{
            imgObj:{
                icon_wu,
                icon_tz,
                icon_r,
                icon_ewm,
                icon_delete,
                icon_w,
                icon_date
            },
            //列表
            riskList:[],
            riskLoading:false,
            //展示类型 list add look not
            isShowType:'',
            ruleForm:{
                companyName:'',
                taxpayerId:'',
            },
            rules:{
                companyName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                ],
                taxpayerId:[
                    { required: true, message: '请输入15 18 20 位数税号', trigger: 'blur' },
                ]
            },
            //loading
            addRiskLoading:false,
            authLoading:false,
            orderLoading:false,
            //风险报告
            orderList:[],
            myWindow:'',
            listTimer:null,
            fileLoading:false,
        }
    },
    mounted(){
        this.getRiskData()
    },
    methods:{
        //获取列表
        getRiskData(){
            let data = {
                advanced: true,
                orders: [{asc: true, column: ""}],
                pageNo: 1,
                pageSize: 99,
                searchEndTime: "",
                searchStartTime: "",
            }
            this.riskLoading = true;
            getRiskList(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    this.riskLoading = false
                    this.riskList = res.data.rows;
                    this.isShowType = 'list'
                    //判断是否为空
                    if(this.riskList.length==0){
                        this.isShowType = 'not'
                    }
                }
                //console.log(res)
            })
        },
        //打开开通服务
        openAddBtn(){
            this.isShowType = 'add';
        },
        //返回  展现列表
        returnList(type){
            this.isShowType = 'list';
            if(type!='look'){
                //获取列表
                this.getRiskData()
            }
            
            // if(this.riskList.length==0){
            //     this.isShowType = 'not'
            // }
        },
        //点击提交按钮
        addSubmitClick(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addRiskLoading = true;
                    //判断位数
                    if(this.ruleForm.taxpayerId.length==15||this.ruleForm.taxpayerId.length==18||this.ruleForm.taxpayerId.length==20){
                        //提交接口
                        this.getAdd()
                    }else{
                        this.$message(
                            {
                                message:'请输入15 18 20 位数税号',
                                type:'warning',
                            }
                        )
                        this.addRiskLoading = false;
                    }
                }
            });
        },
        //添加风险监测列表数据
        getAdd(){
            getAddRisk(this.ruleForm).then(res => {
                if(res.status == 200 &&res.data.status == 0){
                    this.addRiskLoading = false;
                    //触发返回
                    this.returnList()                
                }
            }).catch(err => {
                console.log(err);
                this.addRiskLoading = false;
                this.$message(
                    {
                        message:'接口升级中~',
                        type:'warning',
                    }
                )
            })
        },
        //阅读报告
        goLook(item){
            this.orderLoading = true;
            let data = {
                entity:item.id
                //entity:20
            }
            this.orderList = [];
            getAuthOrder(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    console.log(res)
                    let tRes = res.data.rows;
                    this.orderLoading = false;
                    //判断是否有订单
                    if(tRes&&tRes.length==0){
                        this.$message({
                            message:'您还没有报告，点击【数据采集】生成报告。',
                            type:'warning'
                        })
                    }else{
                        this.orderList = tRes;
                        this.isShowType = 'look';
                    }
                }
            }).catch(err => {
                console.log(err);
                this.orderLoading = false;
            })
        },
        //数据采集
        goJSP(item){
            let that = this;
            this.authLoading = true;
            let tData = {
                companyName:item.companyName,
                id:item.id,
                taxpayerId:item.taxpayerId,
            }
            getAuth(tData).then(res => {
                //console.log(res)
                if(res.status==200&&res.data.status==0){
                    let thatRes = res.data.data;
                    let jspUrlZSDY = '//tax-inspect-jsp.shui12366.com/'
                    let jspUrl = '//www.wfq2020.com/'
                    let thatUrl = thatRes.replace(jspUrl,jspUrlZSDY);//'http://localhost/index';
                    //window.open(thatUrl,'_blank')
                    //that.myWindow = window.open(thatUrl, "登陆", "width=1400,height=800,top=200,left=200");
                    let data = {
                        entity:item.id,
                        //entity:20
                        pageSize:1,
                    }
                    getAuthOrder(data).then(res => {
                        if(res.status==200&&res.data.status==0){
                            let tTotal = res.data.total;
                            //先清除定时器
                            clearInterval(that.listTimer);
                            that.authLoading = false;
                            //打开页面
                            that.myWindow = window.open(thatUrl, "登陆", "width=1400,height=800,top=200,left=200");
                            //增加定时器 判定
                            that.addGetListTotal(item,tTotal,that.myWindow)
                        }
                    })
                    
                }
            }).catch(err => {
                console.log(err);
                this.authLoading = false;
            })
        },
        //定时器
        addGetListTotal(item,total,tWindow){
            this.listTimer = setInterval(() => {
                let data = {
                    entity:item.id,
                    //entity:20
                    pageSize:1,
                }
                getAuthOrder(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    let tTotal = res.data.total;
                    if(total!=tTotal){
                        //关闭window
                        tWindow.close();
                        //清除定时器
                        clearInterval(this.listTimer);
                        //展示成功
                        this.$message({
                            message:'数据采集成功!',
                            type:'success',
                        });
                    }
                }
            }).catch(err => {
                console.log(err);
                //this.orderLoading = false;
            })
            },4500)
        },
        //去购买
        goMall(){
            let tURL= 'https://zsdy-mall-pc.shui12366.com/goodsType?appCode=aiw';
            window.open(tURL,'_balnk')
        },
        //查看订单
        goMallOrder(){
            let tURL= 'https://zsdy-mall-pc.shui12366.com/order?goodsCode=aiw-year-vip';
            window.open(tURL,'_balnk')
        },
        stateFN(val){
			let text  = '未授权'
			if(val){
				if(val == 1){
					text  = '授权中'
				}
				if(val == 2){
					text  = '授权失败'
				}
				if(val == 3){
					text  = '授权中'
				}
				if(val == 4){
					text  = '授权中'
				}
				if(val == 5){
					text  = '授权成功'
				}
				if(val == 6){
					text  = '已失效'
				}
			}
			return text
		},
        //删除订单
        listDelete(item){
            this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    id:item.id,
                }
                getAuthOrderDelete(data).then(res => {
                    if(res.status==200&&res.data.statu==0){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }).catch(err => {
                    console.lg(err)
                    this.$message({
                        type: 'warning',
                        message: '删除失败!'
                    });
                })
                
            }).catch(() => {
                         
            });
            console.log()
        },
        //阅读全文 (下载报告)
        uploadFile(item){
            this.fileLoading = true;
            //判断是否存在地址
            if(item.fileUrl&&item.fileUrl!=''){
                let tUrl = 'https://zsdy-minio.shui12366.com' + item.fileUrl;
                this.fileLoading = false;
                window.open(tUrl,'_blank');
                
            }else{
                let data = {
                    id:item.id,
					absoluteURL:true
                }
                //获取list详情
                getAuthOrderDetail(data).then(res => {
                    if(res.status==200&&res.data.status==0){
                        let getRes = res.data.data;
                        if(getRes&&getRes.fileUrl&&getRes.fileUrl!=''&&getRes.filename){
							//状态改为已有报告
							item.status = 5
                            window.open(getRes.fileUrl,'_blank')
						}else{
                            this.$message({
                                type: 'warning',
                                message: '暂未生成报告！!'
                            });
						}
                        this.fileLoading = false;
                    }
                }).catch(err => {
                    console.log(err)
                    this.fileLoading = false;
                })
            }
        },
        
    }
}
</script>

<style lang="scss" scoped>
.fxjcView{
    width:100%;
    min-height:200px;
}
.riskBox{
    width:820px;
    height:380px;
    overflow-y: auto;
    .riskList{
        width:810px;
        height: 180px;
        background: #F8F8F8;
        margin-top:20px;
        .riskListLeft{
            width:56%;
            float:left;
            box-sizing: border-box;
            padding:10px;
            .riskListName{
                width:100%;
                font-size:18px;
                color:#333333;
                font-weight: 700;
                line-height: 32px;
                box-sizing: border-box;
                padding-left:20px;
                .riskListKT{
                    background:#ddf5e9 ;
                    color:#06c05f;
                    padding: 2px 5px;
                    font-size: 14px;
                    margin-left:16px;
                    font-weight: 400;
                }
            }
            .riskListNumber{
                width:100%;
                height:32px;
                font-size:16px;
                color:#333333;
                font-weight: 400;
                line-height: 32px;
                margin-top:6px;
                box-sizing: border-box;
                padding-left:20px;
            }
            .riskListhandle{
                width:100%;
                height:42px;
                text-align: center;
                font-weight: 700;
                margin-top:26px;
                .riskListhandleY{
                    width:120px;
                    height:42px;
                    line-height: 42px;
                    background: #EEF8FF;
                    margin-left:20px;
                    float:left;
                    color:#0F59A4;
                    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                    cursor:pointer;
                }
                .riskListhandleS{
                    width:120px;
                    height:42px;
                    line-height: 42px;
                    background: #0F59A4;
                    margin-left:20px;
                    float:left;
                    color:#ffffff;
                    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                    cursor:pointer;
                }
            }
        }
        .riskListRight{
            width:44%;
            float:left;
            box-sizing: border-box;
            padding:10px;
            .riskListMoney{
                width:100%;
                height:32px;
                line-height: 32px;
                text-align: right;
                color:#0F59A4;
                box-sizing: border-box;
                padding-right:10px;
                span{
                    cursor:pointer;
                }
                img{
                    width:16px;
                    height:16px;
                    position: relative;
                    top:2px;
                    margin-left:6px;
                    cursor:pointer;
                }
            }
            .riskListEndTime{
                width:100%;
                height:32px;
                line-height: 32px;
                margin-top:8px;
            }
            .riskListRightBuy{
                width:100%;
                height:42px;
                text-align: center;
                font-weight: 700;
                margin-top:26px;
                .riskListEWM{
                    width:42px;
                    height:42px;
                    float:left;
                    background: #EEF8FF;
                    cursor:pointer;
                    img{
                        width:26px;
                        height:26px;
                        margin:8px auto;
                    }
                }
                .riskListAdd{
                    width:120px;
                    height:42px;
                    line-height: 42px;
                    background: #EEF8FF;
                    margin-left:20px;
                    float:left;
                    color:#0F59A4;
                    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                    cursor:pointer;
                }
                .riskListGoBuy{
                    width:120px;
                    height:42px;
                    line-height: 42px;
                    background: #0F59A4;
                    margin-left:20px;
                    float:left;
                    color:#ffffff;
                    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
                    cursor:pointer;
                }
            }
        }
    }
}
.lookView{
    width:100%;
    .lookViewTop{
        width:100%;
        height:50px;
        line-height: 50px;
        background: #EEF8FF;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        font-size:16px;
        box-sizing: border-box;
        padding-left:20px;
        color:#8C8C8C;
        position: relative;
        img{
            width:18px;
            height:18px;
            position: relative;
            top:3px;
            margin-right:10px;
        }
        .returnListBtn{
            width:54px;
            height:24px;
            line-height: 24px;
            text-align: center;
            position: absolute;
            top:13px;
            right:16px;
            cursor: pointer;
            background: #0F59A4;
            font-size: 16px;
            color: #FFFFFF;
            border-radius:4px;
        }
    }
    .orderListBox{
        width:820px;
        max-height:500px;
        overflow-y: auto;
        .orderList{
            width:810px;
            height:90px;
            background:#EEF8FF ;
            margin-top:10px;
            box-sizing: border-box;
            padding:8px 12px;
            .orderListTop{
                width:100%;
                height:30px;
                line-height: 30px;
                position: relative;
                //color:#8C8C8C;
                .orderListTopStatus{
                    background:#ddf5e9 ;
                    color:#06c05f;
                    padding: 3px 6px;
                    font-size: 14px;
                    margin-left:16px;
                    font-weight: 400;
                    border-radius: 12px 0px  12px 0px ;
                }
                .listDelete{
                    width:30px;
                    height:30px;
                    position: absolute;
                    right:-10px;
                    top:2px;
                    cursor:pointer;
                    img{
                        width:16px;
                        height:16px;
                    }
                }
            }
            .orderListBottom{
                width:100%;
                height:30px;
                margin-top:10px;
                .orderListBottomTime{
                    width:60%;
                    height:30px;
                    line-height: 30px;
                    float:left;
                    img{
                        width:16px;
                        height:16px;
                        position: relative;
                        top:1px;
                        margin-right:4px;
                    }
                }
                .orderListBottomDown{
                    width: 110px;
                    height:30px;
                    line-height: 30px;
                    text-align: center;
                    background-color: #e1ecfa;
                    border-radius: 30rpx;
                    font-size:15px;
                    float:right;
                    border-radius: 15px ;
                    cursor:pointer;
                    img{
                        width:16px;
                        height:16px;
                        margin-right:6px;
                        position: relative;
                        top:2px;
                    }
                }
            }
        }
    }
}
.addView{
    width:100%;
    .addViewTop{
        width:100%;
        height:50px;
        line-height: 50px;
        background: #EEF8FF;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        font-size:16px;
        box-sizing: border-box;
        padding-left:20px;
        color:#8C8C8C;
        position: relative;
        img{
            width:18px;
            height:18px;
            position: relative;
            top:3px;
            margin-right:10px;
        }
        .returnListBtn{
            width:54px;
            height:24px;
            line-height: 24px;
            text-align: center;
            position: absolute;
            top:13px;
            right:16px;
            cursor: pointer;
            background: #0F59A4;
            font-size: 16px;
            color: #FFFFFF;
            border-radius:4px;
        }
    }
    .addInputBox{
        width:80%;
        box-sizing: border-box;
        padding:40px 0 20px;
        margin:0 auto;
        ::v-deep .el-form-item__label{
            height:48px;
            line-height: 48px;
            font-size:16px;
            color:#333333;
        }
        ::v-deep .el-input__inner{
            height:48px;
            line-height: 48px;
            border: 2px solid #8C8C8C;
            border-radius:0;
            font-size:16px;
        }
    }
    .addRiskBtn{
        width:170px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        color:#ffffff;
        font-size: 18px;
        font-weight: 700;
        cursor:pointer;
        background: #0F59A4;
        margin:30px auto 0;
    }
}

.notData{
    width:100%;
    color:#8C8C8C;
    text-align: center;
    .imgBox{
        width:100%;
        margin-top:40px;
        img{
            width:130px;
        }
    }
    .notDataText1{
        font-size: 18px;
        margin-top:20px;
        font-weight: 700;
    }
    .notDataText2{
        font-size: 16px;
        margin-top:10px;
    }
    .openAddBtn{
        width:170px;
        height:50px;
        margin:30px auto;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color:#ffffff;
        cursor:pointer;
        background: #0F59A4;
    }
}
</style>